import { render, staticRenderFns } from "./Manufacture.vue?vue&type=template&id=37743d54"
import script from "./Manufacture.vue?vue&type=script&lang=js"
export * from "./Manufacture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports